import type { SxProps, Theme } from '@mui/material/styles';

/** Mismo gutter horizontal en header y cuerpo (evita texto pegado al borde del viewport). */
export const publicLayoutHorizontalGutter = {
  xs: 3,
  sm: 4,
  md: 10,
} as const;

export const rootStyles = {
  width: '100%',
  maxWidth: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
} satisfies SxProps<Theme>;

export const contentWrapperStyles = {
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  flex: 1,
  minHeight: 0,
  px: publicLayoutHorizontalGutter,
  py: { xs: 2, sm: 3 },
} satisfies SxProps<Theme>;

export const contentContainerStyles = {
  width: '100%',
  maxWidth: '1200px',
  mx: 'auto',
} satisfies SxProps<Theme>;
